module.exports = __webpack_public_path__ + "img/tech15.7bc40069.png";